import useFetchSelect from 'elements/Hooks/useFetchSelect'
import React from 'react'

function Currency(props) {
  const { SelectData: CurrencySelect } = useFetchSelect({
    url: `dropdowns/general/currency`,
  })

  return <CurrencySelect placeholder={'Select a company'} keyAtr={'code'} valueAtr={'name'} {...props} />
}

export default Currency
